// Function for adding query filter and sort when accessing API profile list
export default function addFilterProfile(param, dataFilter, dataSort) {
  const qs = { ...param }

  if (dataFilter.createStartDate) {
    qs.where.createdAt = {}
    if (dataFilter.createStartDate) {
      qs.where.createdAt['>='] = dataFilter.createStartDate
    }
    if (dataFilter.createEndDate && dataFilter.isCreateEndDateActive) {
      qs.where.createdAt['<='] = dataFilter.createEndDate
    }
  }

  if (dataFilter.lastUpdateStartDate) {
    qs.where.updatedAt = {}
    if (dataFilter.lastUpdateStartDate) {
      qs.where.updatedAt['>='] = dataFilter.lastUpdateStartDate
    }
    if (dataFilter.lastUpdateEndDate && dataFilter.isLastUpdateEndDateActive) {
      qs.where.updatedAt['<='] = dataFilter.lastUpdateEndDate
    }
  }

  if (dataFilter.country) {
    qs.where.country = dataFilter.country
  }

  if (dataFilter.defaultFeature) {
    qs.where.defaultFeature = dataFilter.defaultFeature
  }

  if (dataSort.active) {
    qs.sort = `${dataSort.active} ${dataSort[dataSort.active]}`
  }

  if (dataFilter.subscriptionPlan) {
    qs.where.subscriptionPlan = dataFilter.subscriptionPlan
  }

  return qs
}
